module.exports = __webpack_public_path__ + "img/game_splash_small.2f2cabfd.jpg";